import { useState, useEffect } from "react";

function InputCurrency({
  defaultValue = "",
  onChange,
  required,
  symbol = "₱",
  ...props
}) {
  const [displayValue, setDisplayValue] = useState("");

  function format(val) {
    if (val === "") return "";
    const [intPart, decPart] = val.toString().replace(/,/g, "").split(".");
    const formattedInt = intPart
      ? parseInt(intPart, 10).toLocaleString("en-US")
      : "";
    return decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
  }

  useEffect(() => {
    setDisplayValue(format(defaultValue));
  }, [defaultValue]);

  function handleChange(e) {
    const raw = e.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(raw)) return;
    setDisplayValue(format(raw));
    onChange?.(raw);
  }

  return (
    <div className="input-group">
      <span className="input-group-text">{symbol}</span>
      <input
        type="text"
        className="form-control"
        value={displayValue}
        onChange={handleChange}
        required={required}
        {...props}
      />
    </div>
  );
}

export default InputCurrency;
